import { GET, POST } from "@/services/request";
import * as APIs from '@/services/APIs';

/**
 * 获取会员详情下拉框数据
 */
export const fetchAccountBasic = async () => {
    const res = await GET(APIs.API_CITY_GETACCOUNTBASIC);

    return res.data.data ?? {};
};

/**
 * 获取黑书会员下拉框数据
 */
export const fetchBlackBookMemberList = async () => {
    const res = await GET(APIs.API_CITY_GETBLACKBOOKMEMBER);

    return res.data.data ?? {};
};

/**
 * 获取入会礼包列表
 */
export const fetchMbrCeremonyList = async () => {
    const res = await GET(APIs.API_MEMBERSHIP_CEREMONY_LIST);

    return res.data.data ?? [];
};

/**
 * 发放入会礼放入卡包暂不兑换/发放入会礼并兑换
 */
export const fetchSendMembershipCeremony = async (data) => {
    const res = await POST(APIs.API_MEMBER_SENDMEMBERSHIPCEREMONY, {
        data,
    });

    return res.data ?? {};
};

/**
 * 获取客户列表
 */
export const fetchCustomerList = async (params) => {
    const res = await GET(APIs.API_MEMBER_INDEX, {
        params,
    });

    return res.data.data ?? {};
};

/**
 * 获取停车优惠原因
 */
export const fetchParkingBasic = async () => {
    const res = await GET(APIs.API_CITY_GETPARKINGBASIC);

    return res.data.data ?? {};
};

/**
 * 获取用户信息
 */
export const fetchMemberInfo = async (memberId) => {
    const res = await GET(APIs.API_MEMBER_INFO, { params: { member_id: memberId } });

    return res.data.data ?? {};
};

/**
 * 用户端获取用户最后等级变更信息
 */
export const fetchLastLevelInfo = async (memberId) => {
    const res = await GET(APIs.API_MEMBER_LASTLEVELINFO, { params: { member_id: memberId } });

    return res.data.data ?? {};
};

/**
 * 获取非用户信息
 */
export const fetchNotMemberInfo = async (memberId) => {
    const res = await GET(APIs.API_MEMBER_NOTMEMBERINFO, { params: { not_member_id: memberId } });

    return res.data.data ?? {};
};

/**
 * 校验手机号码是否有效
 */
export const fetchPhoneVerify = async (params) => {
    const res = await GET(APIs.API_MEMBER_PHONEVERIFY, { params });

    return res.data.data ?? {};
};

/**
 * 获取小票记录列表
 */
export const fetchReceiptList = async (params) => {
    const res = await GET(APIs.API_MEMBER_RECEIPTLIST, {
        params,
    });

    return res.data.data ?? {};
};

/**
 * 删除小票
 */
export const fetchDeleteTicket = async (memberId) => {
    const res = await POST(APIs.API_MEMBER_DELETETICKET, {
        data: {
            id: memberId
        },
    });

    return res.data.data ?? {};
};

/**
 * 获取RSVP记录列表
 */
export const fetchRSVPList = async (params) => {
    const res = await GET(APIs.API_MEMBER_RSVPLIST, {
        params,
    });

    return res.data.data ?? {};
};

/**
 * 获取兑换记录列表
 */
export const fetchConvertTicketList = async (params) => {
    const res = await GET(APIs.API_MEMBER_CONVERTTICKETLIST, {
        params,
    });

    return res.data.data ?? {};
};

/**
 * 获取会员操作日志
 */
export const fetchMemberLogList = async (params) => {
    const res = await GET(APIs.API_MEMBER_MEMBERLOGLIST, {
        params,
    });

    return res.data.data ?? {};
};

/**
 * 获取大使数据
 */
export const fetchGePcsList = async () => {
    const res = await GET(APIs.API_BASIC_GETGEPCSLIST);

    return res.data.data ?? {};
};

/**
 * 添加编辑会员
 */
export const fetchAddeEditMember = async (options) => {
    const res = await POST(APIs.API_MEMBER_ADDEDITMEMBER, options);

    return res.data.data ?? {};
};

/**
 * 添加编辑非会员
 */
export const fetchAddeEditNotMember = async (options) => {
    const res = await POST(APIs.API_MEMBER_ADDEDITNOTMEMBER, options);

    return res.data.data ?? {};
};

/**
 * 会员升降级
 */
export const fetchUpgradeLevel = async (options) => {
    const res = await POST(APIs.API_MEMBER_UPGRADELEVEL, options);

    return res.data ?? {};
};

/**
 * 邀请成为奕尚
 */
export const fetchUpgradeYishang = async (options) => {
    const res = await POST(APIs.API_MEMBER_UPGRADEYISHANG, options);

    return res.data.data ?? {};
};

/**
 * 优惠停车
 */
export const fetchParking = async (data) => {
    const res = await POST(APIs.API_MEMBER_PARKING, { data });

    return res.data ?? {};
};

/**
 * 获取优惠停车历史记录
 */
export const fetchParkingList = async (params) => {
    const res = await GET(APIs.API_MEMBER_PARKINGLIST, {
        params,
    });

    return res.data.data ?? {};
};
